import apiClient from './apiClient';
import type { CreateSiteRequest, Site, SiteDetailsResponse, SiteWithCounts } from '../types/project';

export const getSites = async (): Promise<Site[]> => {
  const response = await apiClient.get<Site[]>('/sites');
  return response.data;
};

export const getSitesWithCounts = async (): Promise<SiteWithCounts[]> => {
  const response = await apiClient.get<SiteWithCounts[]>('/sites/with-counts');
  return response.data;
};

export const getSiteById = async (siteKey: string): Promise<Site> => {
  const response = await apiClient.get<Site>(`/sites/${siteKey}`);
  return response.data;
};

export const getSiteLocations = async (siteKey: string): Promise<SiteDetailsResponse> => {
  const response = await apiClient.get<SiteDetailsResponse>(`/sites/${siteKey}/locations`);
  return response.data;
};

export const createSite = async (data: CreateSiteRequest): Promise<Site> => {
  const response = await apiClient.post<Site>('/sites', data);
  return response.data;
};

export const updateSite = async (siteKey: string, data: Partial<CreateSiteRequest>): Promise<Site> => {
  const response = await apiClient.put<Site>(`/sites/${siteKey}`, data);
  return response.data;
};

export const deleteSite = async (siteKey: string): Promise<void> => {
  await apiClient.delete(`/sites/${siteKey}`);
};
